import React, { useState, useEffect, useRef, Key } from 'react';
import { ITreeData, IYhFormRef } from '@src/components/YhFormBox/Types';
import { createModel } from 'hox';
import { message } from 'antd';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { IPgProps, ISearchPage } from '@src/types/FmsTypes';
import {
	ISVehicleResourceFields,
	ISVehicleResourceSearch,
} from '../vehicleResource/VehicleResourceTypes';
import { sVehicleResourceService } from '../vehicleResource/VehicleResourceService';
import { globalPrompt } from '@src/components/YhMessage';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@src/utils/constants';
import { transPgToPagination } from '@src/utils/utils';
import {
	ISaleOrderSearch,
	ISaleOrderDetail,
	ISaleOrderFields,
	IDetailList,
	IDetailOne,
	ShcVehicle,
	ShcProcess,
	ShcContract,
	ISaleOrderVehicleDetail,
	IDelete,
} from './orderTypes';
import { saleOrderService } from './orderService';
import moment from 'moment';
import useGlobalModel from '@src/model/globalModel';
export const useSaleOrderModel = createModel(function () {
	let saleSteps: ShcProcess[] = [
		{
			status: 1,
			code: '已报价',
			name: '报价',
			principalName: '',
			userCode: '',
			dateTime: '',
			id: '',
		},
		{
			status: 2,
			code: '签合同',
			name: '签合同',
			principalName: '',
			principalCode: '',
			userCode: '',
			dateTime: '',
			id: '',
		},
		{
			status: 3,
			code: '已付款',
			name: '付款',
			principalName: '',
			principalCode: '',
			userCode: '',
			dateTime: '',
			id: '',
		},
		{
			status: 4,
			code: '已报关',
			name: '报关',
			principalName: '',
			principalCode: '',
			userCode: '',
			dateTime: '',
			id: '',
		},
		{
			status: 5,
			code: '已发运',
			name: '发运',
			principalName: '',
			principalCode: '',
			userCode: '',
			dateTime: '',
			id: '',
		},
		{
			status: 6,
			code: '已清关',
			name: '清关',
			principalName: '',
			principalCode: '',
			userCode: '',
			dateTime: '',
			id: '',
		},
		{
			status: 7,
			code: '已售出',
			name: '确认收货',
			principalName: '',
			principalCode: '',
			userCode: '',
			dateTime: '',
			id: '',
		},
	];
	const initSearchParam: ISaleOrderFields = {};
	// 新增车源信息的初始搜索条件
	const initSRSearchParam: ISVehicleResourceFields = {};
	const initDataSource: ISaleOrderDetail[] = [];
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const { user } = useGlobalModel();
	const formRef = useRef<IYhFormRef>();
	//查询条件
	const [searchParam, setSearchParam] = useState<ISaleOrderFields>(initSearchParam);
	//列表数据源
	const [dataSource, setDataSource] = useState<ISaleOrderDetail[]>(initDataSource);
	//表格选中行Key值
	const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
	//表格选中的值
	const [selectedRow, setSelectedRow] = useState<ISaleOrderDetail>({});
	//列表数据源分页参数
	const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
	//新增车源信息弹框
	const [drawerVisible, setDrawerVisible] = useState(false);
	// 查看车源信息详情的弹框
	const [lookDrawerVisible, setLookDrawerVisible] = useState(false);

	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<IDetailOne>({});
	//查看详情列表
	const [detailLookList, setDetailLookList] = useState<IDetailOne[]>([]);

	//详情数据
	//详情列表参数
	const [detailDataSource, setDetailDataSource] = useState<ShcVehicle[]>([]);
	//详情表格选中行
	const [detailDataRowKeys, setDetailDataRowKeys] = useState<ISaleOrderFields[]>([]);
	const [detailDataRow, setDetailDataRow] = useState<ShcVehicle[]>([]);
	const [detailEditForm, setDetailEditForm] = useState<IDetailOne>({});

	// 车源信息列表配置
	const [workDataSource, setWorkDataSource] = useState<ISVehicleResourceFields[]>([]);
	const [searchWorkData, setSearchWorkData] = useState<ISVehicleResourceFields>(initSRSearchParam);
	const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
	//已选车源列表
	const [addDataSource, setAddDataSource] = useState<ISVehicleResourceFields[]>([]);

	// 新增变量控制进度条
	const [steps, setSteps] = useState<ShcProcess[]>([]);
	// 合同内容
	const [contract, setContract] = useState<ShcContract[]>([]);
	const [process, setProcess] = useState<ShcProcess[]>([]);
	const [status, setStatus] = useState(0);
	const [step, setStep] = useState<ShcProcess[]>(saleSteps);
	const [lookFormVal, setLookFormVal] = useState<ISaleOrderVehicleDetail>({});

	useEffect(() => {
		let filters = dataSource.filter((el) =>
			selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false
		);
		const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
		setSelectedRow(selectedData as ISaleOrderFields);
	}, [selectedRowKeys]);

	const updatePgCfg = (updateParam: TablePaginationConfig) => {
		setPgCfg({ ...pgCfg, ...updateParam });
	};
	const updateSearchParam = (updateParam: ISaleOrderFields) => {
		setSearchParam({ ...searchParam, ...updateParam });
	};
	const resetSearchParam = () => {
		setSearchParam(initSearchParam);
		loadData(initPgCfg, {});
		setSelectedRowKeys([]);
		setSelectedRow({});
	};

	// 编辑表单缓存
	const updatEditFormVal = (val: IDetailOne) => {
		let newVal = val;
		setDetailEditForm({ ...detailEditForm, ...newVal });
	};

	//获取一条编辑或查看数据
	const getDetailEditOne = async (id: string, pattern: string) => {
		let { retData } = await saleOrderService.one(id);
		const { ShcProcess, ShcVehicle, ShcContract, createTime, ...form } = retData;

		const vehicleDetails = ShcVehicle?.map((vehicle) => {
			return {
				...vehicle,
				key: vehicle.id,
			};
		});
		let arr = [...saleSteps];
		const processDetails: ShcProcess[] = [...step];
		ShcProcess?.forEach((process) => {
			let { id, principalName, dateTime, status } = process;
			if (status !== 0) {
				let findIndex = processDetails.findIndex((item) => item.status === process.status);
				if (findIndex !== -1) {
					processDetails.splice(findIndex, 1, process);
				}
			}
		});

		const contractDetails = ShcContract?.map((contract) => {
			let { modelName, number, price, totalPrice, id, updateUser, orderNum, vehicleModel } =
				contract;
			return {
				...contract,
				modelName,
				number,
				price,
				totalPrice,
				id,
				updateUser,
				orderNum,
				vehicleModel,
			};
		});
		let arr1: any = ShcProcess?.map((item) => {
			return item.status;
		});
		let maxStatus = Math.max.apply(null, arr1);
		console.log(maxStatus, ShcProcess);
		setProcess(ShcProcess as ShcProcess[]);
		let ShcProcessStatus = ShcProcess && maxStatus;
		if (retData && pattern == 'edit') {
			setDetailDataSource((vehicleDetails as IDetailOne[]) ?? []);
			setDetailEditForm({
				...form,
				createTime: moment(createTime).format('YYYY-MM-DD HH:mm:ss'),
			});
			setContract((contractDetails as ShcContract[]) ?? []);
			setStatus(ShcProcessStatus as number);
			setStep(processDetails);
			setDetailDataRow((vehicleDetails as IDetailOne[]) ?? []);
		} else if (retData && pattern == 'look') {
			setDetailLookForm({
				...form,
				createTime: moment(createTime).format('YYYY-MM-DD HH:mm:ss'),
			});
			setDetailLookList((vehicleDetails as IDetailOne[]) ?? []);
			setStatus(ShcProcessStatus as number);
			setContract((contractDetails as ShcContract[]) ?? []);
			setStep(processDetails);
			setDetailDataRow((vehicleDetails as IDetailOne[]) ?? []);
		}
	};

	//关闭弹框
	const resetWorkloadData = async () => {
		setSearchWorkData({});
		workloadData(initPgCfg, {});
	};

	//加载车源数据(弹框)
	const workloadData = async (
		page?: ISearchPage,
		searchValue: ISVehicleResourceFields = searchWorkData
	) => {
		const searchParams: ISVehicleResourceSearch = {
			status: 1,
			...searchValue,
			pg: {
				pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
				pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
			},
		};
		let { retData } = await sVehicleResourceService.page(searchParams);
		const { items, ...pg } = retData;
		const newRecords = items.map((item) => {
			return {
				...item,
			};
		});
		setWorkPgCfg(transPgToPagination(pg));
		setWorkDataSource(items);
	};

	// 加载列表数据
	const loadData = async (page?: ISearchPage, searchValue: ISaleOrderDetail = searchParam) => {
		const searchParams: ISaleOrderSearch = {
			...searchValue,
			insertType: 'sales',
			pg: {
				orders: [
					{
						rule: 'ASC',
						column: 'createTime',
					},
				],
				pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
				pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
			},
		};
		let { retData } = await saleOrderService.page(searchParams);
		const { items, ...pg } = retData;
		setPgCfg(transPgToPagination(pg));
		setDataSource(items);
	};

	//筛选模块详情 详情和新增的列表已有数据的方法
	const modelScreenMethod = async (
		modelList: ISVehicleResourceFields[],
		detailList: ShcVehicle[]
	) => {
		const repetition: string[] = [];
		const newDetailData: IDetailOne[] = [];
		modelList.forEach((Item) => {
			let isSelect = detailList && detailList.find((item) => item.vehicleCode === Item.vehicleCode);
			if (isSelect === undefined) {
				newDetailData.push({
					...Item,
					key: Item.id,
					id: '',
				});
			} else {
				repetition.push(Item.vehicleCode as string);
			}
		});
		//新增的时候添加合同信息
		let contractArr = [...contract];
		console.log(newDetailData);
		newDetailData.forEach((item) => {
			let isHave = contract.find(
				(origin) => item.modelCode === origin.modelCode && item.vehicleModel === origin.vehicleModel
			);
			if (isHave) {
				let num = +(isHave.number ?? 0) + 1;
				let price = +(isHave.price ?? 0);
				isHave.number = num;
				isHave.totalPrice = num * price;
				let findIndex = contractArr.findIndex((item) => item.id === isHave?.id);
				contractArr.splice(findIndex, 1, isHave);
			} else {
				contractArr.push({
					modelCode: item.modelCode,
					modelName: item.modelName,
					vehicleModel: item.vehicleModel,
					number: 1,
					price: 0,
					totalPrice: 0,
					orderId: item.id ?? '',
				});
			}
		});
		setContract(contractArr);
		return { newDetailData, repetition };
	};

	//添加到详情列表
	const transformsToPoDetailList = async (mode: string) => {
		//详情列表
		if (mode === 'edit') {
			const { repetition, newDetailData } = await modelScreenMethod(
				addDataSource,
				detailDataSource
			);
			setDetailDataSource([...detailDataSource, ...newDetailData]);
			repetition.length != 0 &&
				globalPrompt('message', {
					text: `车源信息${repetition.join(',')}，重复的将不在添加。`,
					type: 'warning',
				});
		}
	};
	//删除详情列表数据
	const detailDetailList = async (mode: string) => {
		//删除商品
		if (!detailDataRowKeys.length) {
			message.warning('请选择你要删除的商品');
			return;
		}
		const conctractArr = [...contract];
		let deleteArr: IDelete = {
			ShcVehicle:
				detailDataRowKeys.filter((item) => item.id).map((item) => ({ id: item.id ?? '' })) ?? [],
			ShcContract:
				conctractArr.filter((item) => item.id).map((item) => ({ id: item.id ?? '' })) ?? [],
		};

		if (deleteArr.ShcVehicle.length) {
			await saleOrderService.delete(deleteArr);
		}
		let filterArr: string[] = detailDataRowKeys.map((item) => item.key ?? '');
		setDetailDataSource((origin) =>
			origin.filter((item) => filterArr.indexOf(item.key as string) < 0)
		);
		setSelectedRowKeys([]);
		//删除车辆信息时候删除合同信息
		let contractArr = [...contract];

		detailDataRowKeys.forEach((item) => {
			let isHave = contract.find(
				(origin) => item.modelCode === origin.modelCode && item.vehicleModel === origin.vehicleModel
			);
			if (isHave) {
				let findIndex = contractArr.findIndex((item) => item.id === isHave?.id);
				if (+(isHave.number ?? 0) > 1) {
					isHave.number = +(isHave.number ?? 0) - 1;
					contractArr.splice(findIndex, 1, isHave);
					return;
				}
				contractArr.splice(findIndex, 1);
			}
		});
		setContract(contractArr);
		message.success('删除成功');
	};

	//编辑采购订单
	const editDetail = async (params: IDetailOne) => {
		let newParams = {
			...params,
		};
		let { retData } = await saleOrderService.update(newParams);
		return retData;
	};

	// 取消订单
	const concelOrder = async (id: string) => {
		const params = {
			id,
		};
		const { retData } = await saleOrderService.remove(params);
		if (retData) {
			let status = 9;
			setStatus(status);
			globalPrompt('message', { type: 'success', text: '取消成功!' });
		} else {
			globalPrompt('message', { type: 'error', text: '取消失败!' });
		}
	};

	// 获取一条车辆信息查看
	const getVehicleDetailOne = async (id: string) => {
		let { retData } = await saleOrderService.findOne(id);
		let { ...form } = retData;
		if (retData) {
			setLookFormVal(form);
		} else {
			globalPrompt('message', { type: 'success', text: '操作失败请重试!' });
		}
	};

	//关闭页签清不同状态缓存
	const resetEditCatch = async () => {
		setDetailEditForm({});
		setDetailDataSource([]);
		setStep(saleSteps);
		setContract([]);
	};

	return {
		formRef,
		initPgCfg,
		searchParam,
		setSearchParam,
		dataSource,
		setDataSource,
		selectedRowKeys,
		setSelectedRowKeys,
		selectedRow,
		setSelectedRow,
		pgCfg,
		setPgCfg,
		drawerVisible,
		setDrawerVisible,
		updatePgCfg,
		updateSearchParam,
		resetSearchParam,
		loadData,
		detailLookForm,
		setDetailLookForm,
		detailLookList,
		setDetailLookList,
		lookDrawerVisible,
		setLookDrawerVisible,
		detailDataSource,
		setDetailDataSource,
		detailDataRowKeys,
		setDetailDataRowKeys,
		detailDataRow,
		setDetailDataRow,
		detailEditForm,
		setDetailEditForm,
		workDataSource,
		setWorkDataSource,
		searchWorkData,
		setSearchWorkData,
		workPgCfg,
		setWorkPgCfg,
		addDataSource,
		setAddDataSource,
		updatEditFormVal,
		getDetailEditOne,
		resetWorkloadData,
		workloadData,
		transformsToPoDetailList,
		detailDetailList,
		editDetail,
		resetEditCatch,
		steps,
		setSteps,
		contract,
		setContract,
		concelOrder,
		process,
		setProcess,
		status,
		setStatus,
		step,
		setStep,
		lookFormVal,
		setLookFormVal,
		getVehicleDetailOne,
	};
});
